import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON } from 'react-leaflet';
import { geoJson } from 'leaflet';

import { getAreaList, getAreaPolygon } from '../../../ajax/endpoints';

export class CommunityProfilePolygonComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poly: null,
    };
    this.setPolygon = this.setPolygon.bind(this);
  }

  componentDidMount() {
    const { onBoundsUpdate, organization, profile } = this.props;
    this.setPolygon(organization, profile, onBoundsUpdate);
  }

  setPolygon(organization, profile, onBoundsUpdate) {
    return getAreaList(organization, 'communities')
    .then(communities => {
      return communities.map(community => community.id).join(',');
    })
    .then(communities => {
      return getAreaPolygon('communities', [communities], true);
    })
    .then(poly => {
      if (!poly || (Array.isArray(poly) && poly.length === 0)) {
        return;
      }
      if (this.props.setViewerPolygon) this.props.setViewerPolygon(poly);
      this.setState(({ poly }));
      onBoundsUpdate(geoJson(poly[0]).getBounds());
    });
  }

  render() {
    const { lineColor, fillColor, fillOpacity } = this.props.profile;
    if (this.state.poly) {
      return (<GeoJSON
        data={
          this.state.poly
        }
        style={{
          weight: 1,
          color: lineColor,
          fillColor,
          fillOpacity,
        }}
      />);
    }
    return null;
  }
}

CommunityProfilePolygonComponent.propTypes = {
  onBoundsUpdate: PropTypes.func,
  organization: PropTypes.string,
  profile: PropTypes.object,
  setViewerPolygon: PropTypes.func,
};

export default CommunityProfilePolygonComponent;



// WEBPACK FOOTER //
// ./src/components/Map/Layers/CommunityProfilePolygon.js